export * from "./time.js";
export * from "./destinations.js";

export const isMobileDevice = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.platform)
  );
};

export const phoneNumberFormatter = (number) => {
  if (!number) {
    return;
  }

  // Remove non-digit characters from the input
  let allNumericNumber = number.replace(/\D/g, "");

  if (allNumericNumber.length <= 10) {
    // Format as a US-style phone number
    return allNumericNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  } else {
    // Extract the country code
    let countryCode = allNumericNumber.substring(
      0,
      allNumericNumber.length - 10
    );

    // Extract the remaining phone number
    let remainingDigits = allNumericNumber.substring(
      allNumericNumber.length - 10
    );

    // Format the remaining phone number
    const formattedNumber = remainingDigits.replace(
      /(\d{3})(\d{3})(\d{4})/,
      "($1) $2-$3"
    );

    // Adding '+' before country code
    return "+" + countryCode + " " + formattedNumber;
  }
};

export const isValidPhoneNumber = (number) => {
  if (!number) {
    return false;
  }

  // Remove non-digit characters from the input
  const digitsOnly = number.replace(/\D/g, "");

  // Valid phone numbers should have 10 digits (US) or 11 digits (with country code 1)
  return digitsOnly.length === 10 || (digitsOnly.length === 11 && digitsOnly.startsWith("1"));
};

export const isWhiteLabel = () => {
  const mainDomains = ["app.voxo.co", "localhost", "127.0.0.1"];
  return !mainDomains.includes(window.location.hostname);
};
